export { NpsBadgeComponent } from './nps-badge/nps-badge.component';
